/**
 * LoopNest Media Provider — Pexels
 * Requires VITE_PEXELS_API_KEY environment variable
 * License: Pexels License (free for commercial use)
 * https://www.pexels.com/license/
 */

import { BaseMediaProvider, LICENSE_TYPES, createMediaItem } from './baseProvider';

export class PexelsProvider extends BaseMediaProvider {
  constructor() {
    super({
      id: 'pexels-free',
      label: 'Pexels',
      license: LICENSE_TYPES?.PEXELS,
      requiresAttribution: true,
      baseUrl: 'https://api.pexels.com/v1',
      enabled: !!import.meta.env?.VITE_PEXELS_API_KEY,
    });
    this.apiKey = import.meta.env?.VITE_PEXELS_API_KEY || null;
  }

  async search(query, options = {}) {
    if (!this.apiKey) {
      console.warn('[PexelsProvider] No API key configured. Set VITE_PEXELS_API_KEY.');
      return [];
    }
    const { count = 5 } = options;
    try {
      const res = await fetch(
        `${this.baseUrl}/search?query=${encodeURIComponent(query)}&per_page=${count}&orientation=landscape`,
        { headers: { Authorization: this.apiKey } }
      );
      if (!res?.ok) return [];
      const data = await res?.json();
      return (data?.photos || [])?.map((photo) =>
        createMediaItem({
          id: `pexels-${photo?.id}`,
          url: photo?.src?.landscape || photo?.src?.large2x || photo?.src?.original,
          previewUrl: photo?.src?.medium || photo?.src?.small,
          alt: photo?.alt || query,
          author: photo?.photographer,
          authorUrl: photo?.photographer_url,
          providerId: this.id,
          license: this.license,
          requiresAttribution: this.requiresAttribution,
          width: photo?.width,
          height: photo?.height,
        })
      );
    } catch (err) {
      console.warn('[PexelsProvider] Search failed:', err);
      return [];
    }
  }
}

export const pexelsProvider = new PexelsProvider();
